<div class="task-filter" [attr.data-automation-id]="automationId + '-task-filter-container'">
    <form novalidate #taskFiltersForm="ngForm" autocomplete="off">
        <div class="filter-line">
            <label for="txtDescription"> Task: </label>
            <res-custom-input id="txtDescription" name="description" [field]="filterObject.taskDescription"
                [automationId]="automationId + '-task'" onkeydown="return event.key != 'Enter';"
                [queryFocusChanged]="onInputValueChanged.bind(this, filterObject.taskDescription)"></res-custom-input>
        </div>
        <div class="filter-line" [hidden]="!isOwnerVisible">
            <label for="cmbOwner">Owner: </label>
            <select id="cmbOwner" [(ngModel)]="filterObject.selectedOwner.value" name="owner"
                (ngModelChange)="onSelectionChange('selectedOwner')"
                [ngClass]="{'was-submitted': filterObject.selectedOwner.filterApplied && filterObject.selectedOwner.value !== 'All'}">
                <option *ngFor="let user of ownersList" [value]="user">{{user}}</option>
            </select>
        </div>
        <div class="filter-line">
            <label for="dtpStarted">Started: </label>
            <div class="filter-containment" id="dtpStarted">
                <res-custom-date-time-picker class="date-time-picker" [isFormControl]="true"
                    [formSubmitted]="filterObject.dateStartedAfter.filterApplied" name="dateStartedAfter"
                    ngDefaultControl [inputPlaceholder]="defaultDatePlaceholders[0]"
                    (click)="onDateClick($event,'after')" (focusout)="onFocusLost($event,'after')"
                    [(ngModel)]="filterObject.dateStartedAfter.value"
                    (ngModelChange)="dateValueChanged('dateStartedAfter')"
                    [automationId]="automationId + '-start-on-or-after-date'">
                </res-custom-date-time-picker>
                <div class="pickers-separator">~~</div>
                <res-custom-date-time-picker class="date-time-picker" [isFormControl]="true"
                    [formSubmitted]="filterObject.dateStartedBefore.filterApplied" name="dateStartedBefore"
                    ngDefaultControl [inputPlaceholder]="defaultDatePlaceholders[1]"
                    (click)="onDateClick($event,'before')" (focusout)="onFocusLost($event,'before')"
                    [(ngModel)]="filterObject.dateStartedBefore.value"
                    (ngModelChange)="dateValueChanged('dateStartedBefore')"
                    [automationId]="automationId+ '-start-on-or-before-date'">
                </res-custom-date-time-picker>
            </div>
        </div>
        <div class="filter-line">
            <label for="dtpFinished">Finished:</label>
            <div class="filter-containment" id="dtpFinished">
                <res-custom-date-time-picker class="date-time-picker" ngDefaultControl [isFormControl]="true"
                    [formSubmitted]="filterObject.dateFinnishedAfter.filterApplied" name="dateFinnishedAfter"
                    [inputPlaceholder]="defaultDatePlaceholders[0]" (click)="onDateClick($event,'after')"
                    (focusout)="onFocusLost($event,'after')" [(ngModel)]="filterObject.dateFinnishedAfter.value"
                    (ngModelChange)="dateValueChanged('dateFinnishedAfter')"
                    [automationId]="automationId + '-finish-on-or-after-date'">
                </res-custom-date-time-picker>
                <div class="pickers-separator">~~</div>
                <res-custom-date-time-picker class="date-time-picker" ngDefaultControl [isFormControl]="true"
                    [formSubmitted]="filterObject.dateFinnishedBefore.filterApplied" name="dateFinnishedBefore"
                    [inputPlaceholder]="defaultDatePlaceholders[1]" (click)="onDateClick($event,'before')"
                    (focusout)="onFocusLost($event,'before')" [(ngModel)]="filterObject.dateFinnishedBefore.value"
                    (ngModelChange)="dateValueChanged('dateFinnishedBefore')"
                    [automationId]="automationId + '-finish-on-or-before-date'">
                </res-custom-date-time-picker>
            </div>
        </div>
        <div class="filter-line">
            <label for="cmbStatus">Status:</label>
            <select id="cmbStatus" [(ngModel)]="filterObject.selectedTaskStatus.value" name="status"
                (ngModelChange)="onSelectionChange('selectedTaskStatus')"
                [ngClass]="{'was-submitted': filterObject.selectedTaskStatus.filterApplied && filterObject.selectedTaskStatus.value !== 'All'}"
                [attr.data-automation-id]="automationId + '-status-dropdown'">
                <option *ngFor="let status of statusList" [value]="status">{{status}}</option>
            </select>
        </div>
        <div class="filter-line" id="FilterActionsID">
            <label for="pResults">Results:</label>
            <div class="filter-containment">
                <res-custom-input name=min [field]="filterObject.minResult" [inputType]="'number'"
                    [placeholderField]="'Minimum ...'" class="min-max-input"
                    [automationId]="automationId + '-results-minimum'"
                    [queryFocusChanged]="onInputValueChanged.bind(this, filterObject.minResult)"></res-custom-input>
                <div class="pickers-separator">~~</div>
                <res-custom-input name=max [field]="filterObject.maxResult" [inputType]="'number'"
                    [placeholderField]="'Maximum ...'" class="min-max-input"
                    [automationId]="automationId + '-results-maximum'"
                    [queryFocusChanged]="onInputValueChanged.bind(this, filterObject.maxResult)"></res-custom-input>
            </div>
            <div class="button-bar">
                <button id="submitBtnId" class="primary-button" type="submit" (click)="applyFilters()"
                    [ngClass]="{'thin-button': labelVisible() ? false : true}"
                    title="{{!labelVisible() ? 'Apply' : ''}}" [attr.data-automation-id]="'primary-button'">
                    <i class="fa fa-check"></i><span *ngIf="labelVisible()">Apply</span></button>
                <button id="clearBtnId" class="secondary-button" type="reset" (click)="clearFilters()"
                    [ngClass]="{'thin-button': labelVisible() ? false : true}"
                    title="{{!labelVisible() ? 'Clear All' : ''}}" [attr.data-automation-id]="'secondary-button'">
                    <i class="fa fa-close"></i><span *ngIf="labelVisible()">Clear All</span></button>
            </div>
        </div>
    </form>
</div>